import { TCountry } from '$services/api'
import { getThemedData } from '$utils'
import { TCountryCode } from 'countries-list'
import { create } from 'zustand'

interface IOption {
  label: string
  value: string
}

interface ICountryState {
  countries: TCountry[]
  countryOptions: IOption[]
  phoneOptions: IOption[]

  updateCountries: (countries: ICountryState['countries']) => void
}

const ALLOWED_MOTTO_COUNTRY_CODES: TCountryCode[] = ['TH']

const getOptions = (countries: TCountry[]) => {
  const countryOptions = countries.map(v => ({
    label: v.name,
    value: `${v.id}`
  }))

  const phoneOptions = countries.map(v => ({
    label: v.phone_code,
    value: v.phone_code
  }))

  return { countryOptions, phoneOptions }
}

export const useCountryStore = create<ICountryState>()(set => ({
  countries: [],
  countryOptions: [],
  phoneOptions: [],

  updateCountries: countries =>
    set(() => {
      const base = getThemedData({
        carro: countries,
        motto: countries.filter(({ country_code }) =>
          ALLOWED_MOTTO_COUNTRY_CODES.includes(country_code as TCountryCode)
        )
      })
      const { countryOptions, phoneOptions } = getOptions(base)
      return { countries, countryOptions, phoneOptions }
    })
}))
